import { mergeClassNames } from '@/utils';

import styles from './Indicator.module.css';

import type { CSSProperties } from 'react';

interface IIndicatorProps {
  color?: string;
  className?: string;
}

export const Indicator = ({ color = 'var(--ion-color-teal550)', className }: IIndicatorProps) => {
  return (
    <div className={mergeClassNames(styles.indicator, className)} style={{ '--background': color } as CSSProperties} />
  );
};
